import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import OutsideClickHandler from "react-outside-click-handler";
import fp from "lodash/fp";
import clsx from "clsx";
import PopperMenu from "../../../../components/tooltip/PopperMenu";
import {IconAdd, IconOpenInNew, IconMoreVert, IconMoreHoriz} from "@mzc-cloudplex/icons";
import { Tooltip, IconButton } from "@mzc-pdc/ui";

const WidgetHead = ({ title, icon, color, name, removable, onDelete, onRefresh, onMoreView, externalLink }) => {
    const { t } = useTranslation();
    const [openLayer, setOpenLayer] = useState(false);
    const handleTrigger = useCallback(() => {
        setOpenLayer(!openLayer);
    }, [openLayer]);

    return (
        <div className={"head"}>
            <div className={`head-grid`}>
                <span style={{ backgroundColor: `${color ? color : "#11193f"}` }}>{icon}</span>
                <strong>{title}</strong> &nbsp;
                {onMoreView && (
                    <button className="btn btn-icon-solid" onClick={onMoreView}>
                        <IconAdd size={10} />
                    </button>
                )}
                {externalLink && (
                    <a href={externalLink} target={`_blank`} className={"btn btn-icon-solid"}>
                        <IconOpenInNew size={12} />
                    </a>
                )}
            </div>
            <div className={`head-grid`}>
                <PopperMenu
                    ButtonComponent={
                        <span>
                            <Tooltip title={t(`common::label::More`, `More`)}>
                                <IconButton circled component={"span"}>
                                    <IconMoreHoriz size={16} />
                                </IconButton>
                            </Tooltip>
                        </span>
                    }
                    menuButtons={[
                        {
                            skipTranslationLabel: t(`common::label::Remove`, "Remove"),
                            onClick: (e) => {
                                onDelete(name);
                            },
                            enable: true,
                            buttonDisabled: !removable,
                        },
                    ]}
                />
                {/* <div className={`trigger`}>
                    <button
                        type={`button`}
                        className={`btn btn-transparent btn-xs btn-dropdown-trigger`}
                        onClick={handleTrigger}
                    >
                        <i className={`sprite sprite-etc-vertical`} />
                    </button>
                    <div className={clsx(`btn-dropdown-layer`,{active: openLayer})}>
                        <OutsideClickHandler
                            onOutsideClick={() => setOpenLayer(false)}
                        >
                            <ul className={`btn-dropdown-list`}>
                                <li>
                                    <button
                                        disabled={!removable}
                                        onClick={() => onDelete(name)}
                                    >{t(`common::label::Remove`)}</button>
                                </li>
                            </ul>
                        </OutsideClickHandler>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

WidgetHead.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.node,
    name: PropTypes.string,
    onDelete: PropTypes.func,
    onRefresh: PropTypes.func,
    onMoreView: PropTypes.func,
    removable: PropTypes.bool,
};

export default WidgetHead;
